import convert from "heic-convert/browser";
import { fileToBuffer, replaceFileExtension } from "@utils/file.util";

export class HeicConverterService {
  public static instance = new HeicConverterService();

  private constructor() {}

  async convert(file: File): Promise<File> {
    const buffer = await fileToBuffer(file);

    const res = await convert({
      buffer: new Uint8Array(buffer),
      format: "JPEG",
    });

    return new File(
      [new Blob([res])],
      replaceFileExtension(file.name, ".jpeg"),
      {
        type: "image/jpeg",
      },
    );
  }
}
